import { LANGUAGE_CODE } from './intl';

// Import all font sources
import '@fontsource/noto-sans/300.css';
import '@fontsource/noto-sans/400.css';
import '@fontsource/noto-sans/500.css';
import '@fontsource/noto-sans/600.css';
import '@fontsource/noto-sans/700.css';
import '@fontsource/noto-sans/900.css';

import '@fontsource/noto-sans-jp/300.css';
import '@fontsource/noto-sans-jp/400.css';
import '@fontsource/noto-sans-jp/500.css';
import '@fontsource/noto-sans-jp/600.css';
import '@fontsource/noto-sans-jp/700.css';
import '@fontsource/noto-sans-jp/900.css';

import '@fontsource/noto-sans-sc/300.css';
import '@fontsource/noto-sans-sc/400.css';
import '@fontsource/noto-sans-sc/500.css';
import '@fontsource/noto-sans-sc/600.css';
import '@fontsource/noto-sans-sc/700.css';
import '@fontsource/noto-sans-sc/900.css';

import '@fontsource/noto-sans-tc/300.css';
import '@fontsource/noto-sans-tc/400.css';
import '@fontsource/noto-sans-tc/500.css';
import '@fontsource/noto-sans-tc/600.css';
import '@fontsource/noto-sans-tc/700.css';
import '@fontsource/noto-sans-tc/900.css';

import '@fontsource/inter/300.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource/inter/900.css';

// Language-specific font configurations
export const LANGUAGE_FONTS = {
  [LANGUAGE_CODE.ENGLISH]: {
    primary:
      '"Inter", "CircularStdBook", "Roboto", "Helvetica", "Arial", sans-serif',
    secondary:
      '"Inter", "CircularStdMedium", "Roboto", "Helvetica", "Arial", sans-serif',
    bold: '"Inter", "CircularStdBold", "Roboto", "Helvetica", "Arial", sans-serif',
    display:
      '"Inter", "CircularStdBlack", "Roboto", "Helvetica", "Arial", sans-serif',
  },
  [LANGUAGE_CODE.JAPANESE]: {
    primary:
      '"Noto Sans JP", "CircularStdBook", "Roboto", "Helvetica", "Arial", sans-serif',
    secondary:
      '"Noto Sans JP", "CircularStdMedium", "Roboto", "Helvetica", "Arial", sans-serif',
    bold: '"Noto Sans JP", "CircularStdBold", "Roboto", "Helvetica", "Arial", sans-serif',
    display:
      '"Noto Sans JP", "CircularStdBlack", "Roboto", "Helvetica", "Arial", sans-serif',
  },
  [LANGUAGE_CODE.CHINESE]: {
    primary:
      '"Noto Sans SC", "CircularStdBook", "Roboto", "Helvetica", "Arial", sans-serif',
    secondary:
      '"Noto Sans SC", "CircularStdMedium", "Roboto", "Helvetica", "Arial", sans-serif',
    bold: '"Noto Sans SC", "CircularStdBold", "Roboto", "Helvetica", "Arial", sans-serif',
    display:
      '"Noto Sans SC", "CircularStdBlack", "Roboto", "Helvetica", "Arial", sans-serif',
  },
  [LANGUAGE_CODE.INDONESIAN]: {
    primary:
      '"Inter", "CircularStdBook", "Roboto", "Helvetica", "Arial", sans-serif',
    secondary:
      '"Inter", "CircularStdMedium", "Roboto", "Helvetica", "Arial", sans-serif',
    bold: '"Inter", "CircularStdBold", "Roboto", "Helvetica", "Arial", sans-serif',
    display:
      '"Inter", "CircularStdBlack", "Roboto", "Helvetica", "Arial", sans-serif',
  },
};

// Get font family based on current language
export const getFontFamily = (fontType = 'primary') => {
  const currentLocale = getCurrentLocale();
  return (
    LANGUAGE_FONTS[currentLocale]?.[fontType] ||
    LANGUAGE_FONTS[LANGUAGE_CODE.ENGLISH].primary
  );
};

// Get all font families for current language
export const getCurrentLanguageFonts = () => {
  const currentLocale = getCurrentLocale();
  return LANGUAGE_FONTS[currentLocale] || LANGUAGE_FONTS[LANGUAGE_CODE.ENGLISH];
};

// Helper function to get current locale
import { getCurrentLocale } from './intl';
